import { UserRole } from '../types';

/**
 * Masque un email : affiche les 2 premiers caractères + ••• + domaine
 * ex: "jean.dupont@gmail.com" → "je•••@gmail.com"
 */
export function maskEmail(email: string): string {
  if (!email) return email;
  const [local, domain] = email.split('@');
  if (!domain) return '•••';
  const visible = local.slice(0, 2);
  return `${visible}•••@${domain}`;
}

/**
 * Masque un téléphone : affiche les 2 premiers et 2 derniers chiffres
 * ex: "06 12 34 56 78" → "06 •• •• •• 78"
 */
export function maskPhone(phone: string): string {
  if (!phone) return phone;
  const digits = phone.replace(/\D/g, '');
  if (digits.length <= 4) return '••••';
  return digits.slice(0, 2) + ' •• •• •• ' + digits.slice(-2);
}

/**
 * Détermine si les contacts doivent être masqués pour cet utilisateur.
 * - COMPANY_ADMIN voit toujours tout
 * - MANAGER et USER : masqué si l'admin a activé maskContacts sur la company
 *   OU toujours masqué par défaut (si maskContacts n'est pas explicitement false)
 */
export function shouldMaskContacts(userRole: UserRole, companyMaskContacts?: boolean): boolean {
  if (userRole === UserRole.COMPANY_ADMIN || userRole === UserRole.SUPER_ADMIN) {
    return false;
  }
  // Par défaut : masqué pour USER et MANAGER
  // Si l'admin active maskContacts, c'est masqué même pour les cas où ça ne l'était pas
  return true;
}

/**
 * Applique le masquage conditionnel sur un email.
 */
export function displayEmail(email: string, userRole: UserRole, companyMaskContacts?: boolean): string {
  if (!email) return email;
  if (shouldMaskContacts(userRole, companyMaskContacts)) return maskEmail(email);
  if (companyMaskContacts) return maskEmail(email);
  return email;
}

/**
 * Applique le masquage conditionnel sur un téléphone.
 */
export function displayPhone(phone: string, userRole: UserRole, companyMaskContacts?: boolean): string {
  if (!phone) return phone;
  if (shouldMaskContacts(userRole, companyMaskContacts)) return maskPhone(phone);
  if (companyMaskContacts) return maskPhone(phone);
  return phone;
}
